import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AiFillPlusCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import Papa from "papaparse";
import AmPmDropdown from "./dropdown";
// import AmPmDropdown from "../Utils/ampm";
export default function AddScheduleCampaign({
  type,
  getAxiosInstance,
  Toast,
  schedule,
  campaignUp,
  selectionType,
  selectedScreen,
  filter,
  screens,
  media,
}) {
  const [IsShowing, setIsShowing] = useState(false);
  const [show, setShow] = useState(false);
  const [campaign, setCampaignName] = useState("");
  const [notes, setNotes] = useState("");
  const [scheduleStartDate, setScheduleStartDate] = useState("");
  const [scheduleEndDate, setScheduleEndDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [ampm, setAmPm] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [dates, setDates] = useState([]);
  const [lastIndex, setLastIndex] = useState(false);
  const [showFromTimeInput, setShowFromTimeInput] = useState(false);
  const [showToTimeInput, setShowToTimeInput] = useState(false);
  console.log("schedule====>", schedule);
  const handleInputChange1 = (e) => {
    // console.log("mmmmmmmmmmmmm   11111111", e.target.value);
    // setFromTime(e.target.value);
    setShowFromTimeInput(true);
    // setFromTime("");
  };

  const handleInputChange2 = (e) => {
    // console.log("mmmmmmmmmmmmm22222222222222222", e.target.value);
    // setFromTime(e.target.value);
    setShowToTimeInput(true);
  };
  let navigate = useNavigate();
  // console.log("1111111111------>", dates);

  const addCampaign = () => {
    if (campaign.trim() === "")
      return Toast.fire({ icon: "error", title: "Campaign name required." });
    // if(notes.trim() === "") return Toast.fire({ icon: 'error', title: 'Campaign notes required' })
    if (startDate === "" && schedule)
      return Toast.fire({
        icon: "error",
        title: "Campaign start date required",
      });

    if (fromTime === "" && schedule)
      return Toast.fire({
        icon: "error",
        title: "Campaign start time required",
      });
    if (toTime === "" && schedule)
      return Toast.fire({ icon: "error", title: "Campaign end time required" });
    if (endDate === "" && schedule)
      return Toast.fire({
        icon: "error",
        title: "Campaign end date  required",
      });

    let params = {
      name: campaign,
      notes,
      selectionType,
      selectedScreen,
      filter: JSON.stringify(filter),
      broadcastNow: true,
      media: media,
      status: "live",
      start_time: startDate,
      end_time: endDate,
      from_time: fromTime,
      to_time: toTime,
      dates: JSON.stringify(dates),
    };
    if (schedule) {
      //   let scheduledStartTime = new Date(scheduleStartDate).getTime();
      //   let scheduledEndTime = new Date(scheduleEndDate).getTime();

      let scheduledStartTime = new Date(`${startDate} ${fromTime}`).getTime();
      let scheduledEndTime = new Date(`${endDate} ${toTime}`).getTime();
      let scheduledFromTime = new Date(fromTime).getTime();
      let scheduledToTime = new Date(toTime).getTime();
      let scheduledDates = new Date(dates).getTime();
      let allTimes = dates.map((e) => e.time);

      let currentTime = new Date().getTime();
      console.log("1111111111------>", allTimes);
      if (currentTime >= scheduledStartTime)
        return Toast.fire({ icon: "error", title: "Cannot schedule on past." });
      if (scheduledEndTime <= scheduledStartTime)
        return Toast.fire({
          icon: "error",
          title: "Cannot end before campaign start.",
        });
      let hasEmptyTime = false;
      allTimes.forEach((f) => {
        f.forEach((d) => {
          console.log("ddddddddddd", d);
          if (!d.from_time || d.to_time === "") {
            hasEmptyTime = true;
          }
        });
      });
      if (hasEmptyTime) {
        return Toast.fire({
          icon: "error",
          title: "Schedule Time cannot be empty.",
        });
      }

      // console.log("eeeeeeeeeeeeeee===>", checkEmptyTime);

      // if (checkEmptyTime) {
      //   return Toast.fire({
      //     icon: "error",
      //     title: "test error start.",
      //   });
      // }
      // return;
      const parsedSchedules = [];
      dates.forEach((date) => {
        date.time.forEach((timestamp) => {
          parsedSchedules.push({
            from_time: new Date(`${date.date} ${timestamp.from_time}`),
            to_time: new Date(`${date.date} ${timestamp.to_time}`),
          });
        });
      });

      params["startTime"] = scheduledStartTime;
      params["end_time"] =
        parsedSchedules[parsedSchedules.length - 1].to_time.toString();
      params["broadcastNow"] = false;
      params["status"] = "schedule";
      params["schedules"] = JSON.stringify(parsedSchedules);
    } else {
      params["startTime"] = new Date().getTime();
      params["endTime"] = new Date().getTime();
      params["broadcastNow"] = true;
    }
    console.log("ppp===>", params);
    // return
    //   if (currentTime >= fromTime)
    //     return Toast.fire({ icon: "error", title: "Cannot schedule on past." });
    //   if (toTime <= fromTime)
    //     return Toast.fire({
    //       icon: "error",
    //       title: "Cannot end before campaign start.",
    //     });

    //   params["startTime"] = fromTime;
    //   params["endTime"] = toTime;
    //   params["broadcastNow"] = false;
    //   params["status"] = "schedule";
    // } else {
    //   params["startTime"] = new Date().getTime();
    //   params["endTime"] = new Date().getTime();
    //   params["broadcastNow"] = true;
    // }

    // console.log("start date=======", startDate);
    // console.log("end date=======", endDate);
    setIsLoading(true);
    let link = "/admin/add-campaign";
    if (campaignUp) {
      params["id"] = campaignUp._id;
      link = "/admin/update-campaign";
    }

    const data = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    getAxiosInstance()
      .post(link, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        // Validating form
        setIsLoading(false);
        console.log(res.data);
        if (res.data.status === "success") {
          Toast.fire({
            icon: "success",
            title: `Campaign ${
              type === "add" ? "added" : "updated"
            } successfully.`,
          });
          handleClose();
          navigate("/broadcasting/campaigns");
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot Process Request" });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401)
          Toast.fire({ icon: "error", title: "Unauthorized Access" });
        console.log(err);
      });
  };

  // console.log("start date=======", startDate);
  // console.log("end date=======", endDate);

  const dateTimeRange = (date) => {
    // console.log("tttttttttttttt", date);
    // console.log("emd date ", endDate);
    var datesArray = [];
    var currentDate = new Date(startDate);
    var endDateObj = new Date(date);

    while (currentDate <= endDateObj) {
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const day = currentDate.getDate().toString().padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      var dateObj = {
        date: new Date(formattedDate),
        time: [
          {
            from_time: fromTime,
            to_time: toTime,
          },
        ],
      };
      // Add the date object to the array
      datesArray.push(dateObj);

      // Increment the current date
      currentDate.setDate(currentDate.getDate() + 1);
    }
    // console.log("00000", datesArray);

    const updatedDatesArray = datesArray.map((e) => ({
      ...e,
      date: new Date(e.date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
    }));
    // console.log("vvvv", updatedDatesArray);
    setDates(updatedDatesArray);
    return updatedDatesArray;
  };

  // const result = dateTimeRange();
  // console.log("cccc", result);

  // useEffect(() => {
  //   // dateTimeRange();
  //   console.log("Dates:", dates);
  // }, [dates]);

  const startDateHandler = async (event) => {
    const newStartDate = event.target.value;
    setStartDate(newStartDate);
    // If end date is already set, recalculate the date range
    if (endDate) {
      dateTimeRange(endDate);
    }
  };

  const endDateHandler = async (event) => {
    // console.log("inside endDateHandler handler", event.target.value);
    setEndDate(event.target.value);
    dateTimeRange(event.target.value);
  };
  // var lastElementInArray = [];

  const addMoreScheduleHandler = async (d) => {
    // console.log("addMoreScheduleHandler", d, fromTime, toTime);
    const anotherTime = {
      from_time: "",
      to_time: "",
    };
    // console.log("time====", anotherTime);
    const updatedDatesArray = dates.map((e) => {
      const currentDate = new Date(e.date);
      const targetDate = new Date(d);

      if (currentDate.toDateString() === targetDate.toDateString()) {
        return {
          ...e,
          time: [...e.time, anotherTime],
        };
      }
      return e;
    });

    // console.log("updatedDatesArray", updatedDatesArray);
    setDates(updatedDatesArray);
    return updatedDatesArray;
  };

  const handleFromTimeChange = (event, index, d) => {
    // console.log("dates=====?", d);
    const updatedFromTime = event.target.value;
    const updatedDates = dates.map((date) => {
      // console.log("inside map date==>", ...date);

      if (date.date === d) {
        return {
          ...date,
          time: date.time.map((time, timeIndex) => {
            if (timeIndex === index) {
              return {
                ...time,
                from_time: updatedFromTime,
              };
            }
            return time;
          }),
        };
      }
      return { ...date };
    });

    setDates(updatedDates); // Update the dates state with the updated array
  };

  const handleToTimeChange = (event, index, d) => {
    const updatedToTime = event.target.value;
    const updatedDates = dates.map((date) => {
      if (date.date === d) {
        return {
          ...date,
          time: date.time.map((time, timeIndex) => {
            if (timeIndex === index) {
              return {
                ...time,
                to_time: updatedToTime,
              };
            }
            return time;
          }),
        };
      }
      return { ...date };
    });

    setDates(updatedDates); // Update the dates state with the updated array
  };

  const deleteScheduleHander = (i, d) => {
    // console.log("deleteScheduleHander===>", d);
    // console.log(" index deleteScheduleHander===>", i);
    const targetDate = d;
    const allDates = [...dates];
    const dateIndex = dates.findIndex((e) => e.date == targetDate);
    allDates[dateIndex].time.splice(i, 1);
    setDates(allDates);
  };

  // Convert date from MM/DD/YYYY to MM-D-YYYY format
  const formatDateForCSV = (dateStr) => {
    const [month, day, year] = dateStr.split("/");
    return `${parseInt(month)}-${parseInt(day)}-${year}`;
  };

  // Convert date from MM-D-YYYY to MM/DD/YYYY format
  const parseDateFromCSV = (dateStr) => {
    const parts = dateStr.split("-");
    if (parts.length !== 3) return null;
    const month = parts[0].padStart(2, "0");
    const day = parts[1].padStart(2, "0");
    const year = parts[2];
    return `${month}/${day}/${year}`;
  };

  // Export dates to CSV
  const exportToCSV = () => {
    if (dates.length === 0) {
      return Toast.fire({
        icon: "error",
        title: "No schedule data to export.",
      });
    }

    const csvData = [];
    csvData.push(["Date", "Start Time", "End Time"]);

    dates.forEach((dateObj) => {
      dateObj.time.forEach((timeObj) => {
        if (timeObj.from_time && timeObj.to_time) {
          csvData.push([
            formatDateForCSV(dateObj.date),
            timeObj.from_time,
            timeObj.to_time,
          ]);
        }
      });
    });

    const csv = Papa.unparse(csvData, {
      delimiter: ";",
      newline: "\n",
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "schedule_campaign.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    Toast.fire({
      icon: "success",
      title: "Schedule exported successfully.",
    });
  };

  // Import dates from CSV
  const handleCSVImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      return Toast.fire({
        icon: "error",
        title: "Please select a valid CSV file.",
      });
    }

    // Read file to detect delimiter
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const firstLine = text.split("\n")[0];
      
      // Detect delimiter (semicolon or comma)
      let delimiter = ";";
      if (firstLine.includes(",") && !firstLine.includes(";")) {
        delimiter = ",";
      } else if (firstLine.includes(";")) {
        delimiter = ";";
      }

      Papa.parse(text, {
        header: false,
        delimiter: delimiter,
        skipEmptyLines: true,
        complete: (results) => {
          const rows = results.data;
          if (rows.length < 2) {
            return Toast.fire({
              icon: "error",
              title: "CSV file is empty or invalid.",
            });
          }

          // Validate header
          const header = rows[0];
          if (
            header[0]?.trim() !== "Date" ||
            header[1]?.trim() !== "Start Time" ||
            header[2]?.trim() !== "End Time"
          ) {
            return Toast.fire({
              icon: "error",
              title: "Invalid CSV format. Expected: Date; Start Time; End Time; (or comma-separated)",
            });
          }

          // Parse data rows
          const importedData = {};
          for (let i = 1; i < rows.length; i++) {
            const row = rows[i];
            if (row.length < 3 || !row[0] || !row[1] || !row[2]) continue;

            const dateStr = row[0].trim();
            const startTime = row[1].trim();
            const endTime = row[2].trim();

            const parsedDate = parseDateFromCSV(dateStr);
            if (!parsedDate) {
              return Toast.fire({
                icon: "error",
                title: `Invalid date format at row ${i + 1}. Expected format: MM-D-YYYY`,
              });
            }

            // Format date to match component's date format
            const formattedDate = new Date(parsedDate).toLocaleDateString(
              "en-US",
              {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }
            );

            if (!importedData[formattedDate]) {
              importedData[formattedDate] = [];
            }

            importedData[formattedDate].push({
              from_time: startTime,
              to_time: endTime,
            });
          }

          // Convert to dates array format and sort chronologically
          const newDates = Object.keys(importedData)
            .map((date) => ({
              date: date,
              time: importedData[date],
            }))
            .sort((a, b) => {
              const dateA = new Date(a.date);
              const dateB = new Date(b.date);
              return dateA - dateB;
            });

          if (newDates.length === 0) {
            return Toast.fire({
              icon: "error",
              title: "No valid data found in CSV file.",
            });
          }

          setDates(newDates);
          
          // Set start and end dates if not already set
          if (!startDate && newDates.length > 0) {
            const firstDate = newDates[0].date;
            const dateObj = new Date(firstDate);
            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
            const day = dateObj.getDate().toString().padStart(2, "0");
            setStartDate(`${year}-${month}-${day}`);
          }

          if (!endDate && newDates.length > 0) {
            const lastDate = newDates[newDates.length - 1].date;
            const dateObj = new Date(lastDate);
            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
            const day = dateObj.getDate().toString().padStart(2, "0");
            setEndDate(`${year}-${month}-${day}`);
          }

          Toast.fire({
            icon: "success",
            title: "Schedule imported successfully.",
          });

          // Reset file input
          event.target.value = "";
        },
        error: (error) => {
          Toast.fire({
            icon: "error",
            title: "Error parsing CSV file.",
          });
          console.error("CSV parsing error:", error);
          event.target.value = "";
        },
      });
    };

    reader.onerror = () => {
      Toast.fire({
        icon: "error",
        title: "Error reading CSV file.",
      });
      event.target.value = "";
    };

    reader.readAsText(file);
  };

  useEffect(() => {
    console.log("Updated datesArray:", dates);
  }, [dates]);

  function handleClose() {
    setIsShowing(false);
    setCampaignName("");
    setNotes("");
    // window.location.reload()
  }

  useEffect(() => {
    if (screens?.length > 0) {
      for (let i = 0; i < screens.length; i++) {
        if (screens[i].status === 1) {
          setShow(true);
          break;
        }
      }
    }
  }, [screens]);

  return (
    <>
      {type === "add" && show && (
        <button
          type="button"
          class="btn btn-dark btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          {/* <i className={`fas ${schedule?"fa-calendar-alt":"fa-clock"}`}></i> {schedule?"Schedule Broadcast":"Broadcast Now"} */}
          Next <i className="fas fa-angle-double-right"></i>
        </button>
      )}
      {type !== "add" && (
        <button
          type="button"
          class="btn btn-success btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          <i className="fas fa-pen"></i>
        </button>
      )}
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{
            display: "block",
            paddingRight: 17,
          }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-md">
            <div className="modal-content" style={{ width: "600px" }}>
              <div className="modal-header">
                <h5 className="modal-title">Create Campaign</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        className="form-control mt-1"
                        id="campaign"
                        placeholder={"Enter Campaign Name"}
                        value={campaign}
                        onChange={(e) => setCampaignName(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <textarea
                        className="form-control mt-1"
                        id="notes"
                        placeholder={"Additional Notes"}
                        value={notes}
                        style={{ resize: "none" }}
                        rows={5}
                        onChange={(e) => setNotes(e.target.value)}
                      />
                    </div>
                    {schedule && (
                      <>
                        <div className="form-group row m-auto" style={{}}>
                          <div
                            className="col-md-4 mb-2"
                            style={{ padding: "0" }}
                          >
                            <div
                              className="form-group row m-auto"
                              style={{
                                // border: "1px solid blue",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  flex: "1",
                                  marginBottom: "0",
                                  // border: "1px solid red",
                                }}
                                className="text-left"
                              >
                                Start Date
                              </p>
                              <input
                                type="date"
                                className="form-control bg-light col-md-7 ml-1"
                                placeholder="DD/MM/YYYY"
                                style={{
                                  fontSize: "12px",
                                  textAlign: "center",
                                  padding: " 0",
                                  margin: "0 !important",
                                }}
                                onChange={startDateHandler}
                              />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ padding: "0" }}>
                            <div
                              className="form-group row m-auto"
                              style={{
                                fontSize: "13px",
                                // border: "1px solid blue",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  // border: "1px solid red",
                                  marginBottom: "0",
                                  flex: "1",
                                }}
                                className="text-center"
                              >
                                From
                              </p>
                              {showFromTimeInput ? (
                                <input
                                  type="time"
                                  className="form-control bg-light col-md-8 mr-1"
                                  placeholder="HH/MM"
                                  style={{
                                    // border: "1px solid red",
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  onChange={(e) => {
                                    setFromTime(e.target.value);
                                    // setShowFromTimeInput(false);
                                    // e.target.blur();
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control bg-light col-md-8 mr-1"
                                  style={{
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  placeholder="HH:MM"
                                  // value={fromTime}
                                  onClick={handleInputChange1}
                                />
                              )}
                            </div>
                          </div>
                          <div className="col-md-4" style={{ padding: "0" }}>
                            <div
                              className="form-group row m-auto"
                              style={{
                                // width: "182px",
                                fontSize: "13px",
                                // border: "1px solid blue",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  // border: "1px solid red",
                                  marginBottom: "0",
                                  flex: "1",
                                }}
                                className=" text-center"
                              >
                                To
                              </p>
                              {showToTimeInput ? (
                                <input
                                  type="time"
                                  className="form-control bg-light col-md-8 mr-1"
                                  placeholder="HH/MM"
                                  style={{
                                    //   border: "1px solid red",
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  onChange={(e) => {
                                    setToTime(e.target.value);
                                    // setShowToTimeInput(false);
                                    // e.target.blur();
                                  }}
                                />
                              ) : (
                                <input
                                  type="text"
                                  className="form-control bg-light col-md-8 mr-1"
                                  style={{
                                    marginLeft: "15px",
                                    fontSize: "13px",
                                  }}
                                  placeholder="HH:MM"
                                  // value={fromTime}
                                  onClick={handleInputChange2}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row m-auto" style={{}}>
                          <div className="col-md-4" style={{ padding: "0" }}>
                            <div
                              className="form-group row m-auto"
                              style={{
                                // border: "1px solid blue",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  flex: "1",
                                  marginBottom: "0",
                                  // border: "1px solid red",
                                }}
                                className="text-left"
                              >
                                End Date
                              </p>
                              <input
                                type="date"
                                className="form-control bg-light col-md-7 ml-1"
                                placeholder="DD/MM/YYYY"
                                style={{
                                  fontSize: "12px",
                                  padding: " 0",
                                  margin: "0 !important",
                                  textAlign: "center",
                                }}
                                // onChange={
                                //   (e) => setEndDate(e.target.value)
                                // }
                                onChange={endDateHandler}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {schedule && (
                      <>
                        <div className="form-control bg-gray-light my-3">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <p style={{ fontSize: "14px", marginBottom: "0" }}>
                              Broadcast Dates
                            </p>
                            <div>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary mr-2"
                                onClick={exportToCSV}
                                disabled={dates.length === 0}
                                style={{ fontSize: "12px" }}
                              >
                                <i className="fas fa-download"></i> Export CSV
                              </button>
                              <label
                                className="btn btn-sm btn-outline-success"
                                style={{ fontSize: "12px", marginBottom: "0" }}
                              >
                                <i className="fas fa-upload"></i> Import CSV
                                <input
                                  type="file"
                                  accept=".csv"
                                  style={{ display: "none" }}
                                  onChange={handleCSVImport}
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {dates.map((e, index) => {
                      // console.log("eeeeeeeeeeeee", e);
                      return (
                        <div
                          className=" row m-auto my-3"
                          style={{
                            // border: "1px solid red",
                            // marginBottom: "10px",
                            paddingBottom: "4px",
                          }}
                        >
                          <div
                            className="col-md-3"
                            style={{
                              // border: "1px solid red",
                              padding: "0",
                              margin: "0",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                // alignItems: "center",
                              }}
                              className=" h-100"
                            >
                              <p
                                style={{
                                  fontWeight: "600",
                                  // border: "1px solid blue",
                                  flex: "1",
                                  marginBottom: "2px",
                                  paddingTop: "7px",
                                }}
                                className="text-center"
                              >
                                {e.date}
                              </p>
                            </div>
                          </div>

                          {/* from to div start */}
                          <div
                            className="col-md-9"
                            style={
                              {
                                // border: "1px solid red",
                              }
                            }
                          >
                            {e.time.map((f, index) => {
                              // console.log("ggggggggggggg", f);
                              return (
                                <div
                                  style={{ marginBottom: "3px" }}
                                  className=" row"
                                  key={f.date}
                                >
                                  <div
                                    className="col-md-5"
                                    style={{
                                      // border: "1px solid blue",
                                      padding: "0",
                                    }}
                                  >
                                    <div
                                      className="d-flex justify-content-space-between align-items-center"
                                      style={
                                        {
                                          // border: "1px solid red",
                                        }
                                      }
                                    >
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          // border: "1px solid red",
                                          flex: "1",
                                          marginBottom: "0",
                                        }}
                                        className="text-left box"
                                      >
                                        From
                                      </p>
                                      <input
                                        type="time"
                                        className="form-control bg-light col-md-8 ml-2 "
                                        placeholder="HH/MM"
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "center",
                                          marginLeft: "auto",
                                          marginRight: "auto",
                                        }}
                                        value={f.from_time}
                                        onChange={(event) =>
                                          handleFromTimeChange(
                                            event,
                                            index,
                                            e.date
                                          )
                                        }
                                      />
                                      {/* <div
                                        style={
                                          {
                                            // border: "1px solid black",
                                            //   padding: "10px",
                                            // height: "36px",
                                            // width: "30px",
                                          }
                                        }
                                        className="bg-light ml-2"
                                      >
                                        <AmPmDropdown />
                                      </div> */}
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-5"
                                    style={{
                                      // border: "1px solid blue",
                                      padding: "0",
                                    }}
                                  >
                                    <div
                                      className="d-flex justify-content-space-between align-items-center"
                                      style={
                                        {
                                          // border: "1px solid red",
                                        }
                                      }
                                    >
                                      <p
                                        style={{
                                          fontSize: "13px",
                                          // border: "1px solid red",
                                          flex: "1",
                                          marginBottom: "0",
                                        }}
                                        className="text-center box"
                                      >
                                        To
                                      </p>
                                      <input
                                        type="time"
                                        className="form-control bg-light col-md-8 ml-3 "
                                        placeholder="HH/MM"
                                        style={{
                                          fontSize: "12px",
                                        }}
                                        value={f.to_time}
                                        onChange={(event) =>
                                          handleToTimeChange(
                                            event,
                                            index,
                                            e.date
                                          )
                                        }
                                      />
                                      {/* <div
                                        style={
                                          {
                                            // border: "1px solid black",
                                            //   padding: "10px",
                                            // height: "36px",
                                            // width: "30px",
                                          }
                                        }
                                        className="bg-light ml-2"
                                      >
                                        <AmPmDropdown />
                                      </div> */}
                                    </div>
                                  </div>

                                  <div
                                    className="col-md-2"
                                    style={{
                                      padding: "0",
                                      // border: "1px solid blue",
                                      display: "flex",
                                      alignItems: "end",
                                    }}
                                  >
                                    <div
                                      className=""
                                      style={{
                                        display: "flex",
                                        alignItems: "end",
                                        justifyContent: "center",
                                        // border: "1px solid red",
                                        flex: "1",
                                      }}
                                    >
                                      {e.time.length - 1 === index ? (
                                        <div
                                          style={{
                                            // border: "1px solid blue",
                                            flex: "1",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            // marginRight: "10px",
                                          }}
                                        >
                                          <AiFillPlusCircle
                                            style={{
                                              fontSize: "20px",
                                            }}
                                            onClick={addMoreScheduleHandler.bind(
                                              this,
                                              e.date
                                            )}
                                          />
                                        </div>
                                      ) : null}
                                      {index > 0 ? (
                                        <div
                                          style={{
                                            // border: "1px solid blue",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flex: "1",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <MdDelete
                                            style={{
                                              fontSize: "22px",
                                            }}
                                            onClick={() =>
                                              deleteScheduleHander(
                                                index,
                                                e.date
                                              )
                                            }
                                          />
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          {/* from to div ends */}
                        </div>
                      );
                    })}

                    {/* previous code */}
                    {/* {schedule && (
                      <div
                        className="form-group"
                        style={{ border: "2px solid red" }}
                      >
                        <label>Start From</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          onChange={(e) => setScheduleStartDate(e.target.value)}
                        />
                      </div>
                    )} */}
                    {/* {schedule && (
                      <div
                        className="form-group"
                        style={{ border: "2px solid red" }}
                      >
                        <label>Continue Till</label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          onChange={(e) => setScheduleEndDate(e.target.value)}
                        />
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                  onClick={(e) => handleClose()}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={(e) => addCampaign()}
                  disabled={isLoading}
                >
                  {type === "add"
                    ? schedule
                      ? "Schedule Broadcast"
                      : "Broadcast Now"
                    : "Save changes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
